import FormattedMessage from 'I18n/components/FormattedMessage';
import { Button } from 'foundations-components/transitional/components/Button';
import { Text } from 'foundations-components/components/Text';
import { Flex } from 'foundations-components/components/Flex';
import { jsx as _jsx } from "react/jsx-runtime";
const DealCount = ({
  count,
  groupingId,
  isUser,
  onDealCountClick,
  ownerId
}) => {
  const dealCount = /*#__PURE__*/_jsx(FormattedMessage, {
    message: "repOverviewTable.cells.dealCount",
    options: {
      count: count || 0
    }
  });
  if (!ownerId) {
    return /*#__PURE__*/_jsx("div", {
      children: dealCount
    });
  }
  return /*#__PURE__*/_jsx(Flex, {
    justifyContent: "end",
    children: /*#__PURE__*/_jsx(Text, {
      as: "small",
      children: /*#__PURE__*/_jsx(Button, {
        "data-test-id": `${groupingId}-deal-count`,
        onClick: () => onDealCountClick([groupingId], ownerId, isUser),
        use: "link",
        children: dealCount
      })
    })
  });
};
export default DealCount;